import { Bed, Users, Shield } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const About = () => {
  const { t } = useLang();
  const stats = [
    { key: "rooms", icon: Bed, value: "13", label: t("about_stat_rooms") },
    { key: "reception", icon: Users, value: "24/7", label: t("about_stat_reception") },
    { key: "priv", icon: Shield, value: "100%", label: t("about_stat_priv") },
  ];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 lg:py-32 bg-[#0b0c10]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs font-heading tracking-[0.3em] text-[#00FF66] uppercase mb-4">
              {t("about_kicker")}
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] text-white">
              {t("about_word_1")}
              <br />
              {t("about_word_2")}
              <br />
              <span className="text-[#00FF66]">{t("about_word_3")}</span>
            </h2>
          </div>

          <div className="lg:col-span-7">
            <div className="border-l-4 border-[#00FF66] pl-6 py-3 mb-8">
              <p className="text-lg text-[#9CA3AF] leading-relaxed">
                <span className="text-white font-semibold">Loka Beds</span>{" "}
                {t("about_p1_1")}{" "}
                <span className="text-white">{t("about_p1_2")}</span>{" "}
                {t("about_p1_3")}{" "}
                <span className="text-[#00FF66] font-semibold">{t("about_p1_4")}</span>
                {t("about_p1_5")}
              </p>
              <p className="text-lg text-[#9CA3AF] leading-relaxed mt-4">
                {t("about_p2_pre")}{" "}
                <span className="text-white italic">{t("about_p2_em")}</span>
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 sm:gap-6 mt-10">
              {stats.map((s) => (
                <div
                  key={s.key}
                  className="p-5 rounded-xl border border-[rgba(0,255,102,0.15)] bg-[#101216]"
                  data-testid={`about-stat-${s.key}`}
                >
                  <s.icon className="text-[#00FF66] w-6 h-6 mb-3" />
                  <div className="font-heading text-3xl font-extrabold text-white">
                    {s.value}
                  </div>
                  <div className="text-xs text-[#9CA3AF] mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
